import styled from 'styled-components';

export const StyledPage = styled.div`
  padding: 0 50px;

  .ant-breadcrumb {
    padding: 21px 0;
  }

  .table-currency {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .contract-title {
    color: ${(props) => props.theme.contractTextTitleColor};
    font-weight: 500;
  }

  a {
    color: inherit;
  }

  .transactions-download {
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;
  }
`;
